import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <Section alternate data-id="element-79">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-80">
        {/* For You */}
        <div data-id="element-81">
          <h3 className="text-2xl font-serif text-[#c9a04e] mb-8 border-b border-[#c9a04e]/30 pb-4" data-id="element-82">
            Es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-83">
            {['estás agotada pero tu mente se acelera al acostarte', 'te despiertas a mitad de noche con pensamientos en bucle', 'quieres algo práctico, corto y repetible', 'te funciona tachar checklists'].map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-84">
                <Check className="w-5 h-5 text-[#c9a04e] mt-1 flex-shrink-0" data-id="element-85" />
                <span className="text-[#f5f0e8]/90" data-id="element-86">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div data-id="element-87">
          <h3 className="text-2xl font-serif text-[#c97070] mb-8 border-b border-[#c97070]/30 pb-4" data-id="element-88">
            No es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-89">
            {["buscas 'curar' una condición médica con un PDF", 'no puedes comprometer 10–15 min por noche durante 7 días', 'estás en crisis severa (en ese caso, esto puede acompañar, no sustituir ayuda)'].map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-90">
                <X className="w-5 h-5 text-[#c97070] mt-1 flex-shrink-0" data-id="element-91" />
                <span className="text-[#f5f0e8]/70" data-id="element-92">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}